// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "body[data-v-3598b24b]{font-family:\"Nimbus\",\"Helvetica Neue\",\"Helvetica\",\"Arial\",sans-serif;font-weight:400}.overlay[data-v-3598b24b]{backface-visibility:hidden;background-color:#000;height:100%;left:0;opacity:0;position:fixed;top:0;width:100%;z-index:230}@media(min-width:768px){.overlay[data-v-3598b24b]{display:block}}.overlay.closing[data-v-3598b24b]{pointer-events:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
